// This should be modern jQuery, in case it's not, we mimic a modern jQuery with existing version
var version = jQuery.fn.jquery.split(' ')[0].split('.')
if ((version[0] < 2 && version[1] < 9) || (version[0] == 1 && version[1] == 9 && version[2] < 1) || (version[0] > 3)) {
  jQuery.fn.jquery = '1.9.1';
}
